

























































































































































































import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { userStore } from '@/utils/store-accessor'

export interface ITheSideNavigationUserItem {
  id: string
  title: string
  key: number | string
  url: string
  icon: string
  depth: number
  canRemove: boolean
  mini: {
    title: string
    icon: string
  }
}

export const defaultNavigationUserItem = (): ITheSideNavigationUserItem => ({
  id: '',
  title: '',
  key: '',
  url: '',
  icon: '',
  depth: 1,
  canRemove: false,
  mini: {
    title: '',
    icon: ''
  }
})

@Component({
  components: {}
})
export default class TheSideNavigationUser extends ComponentVue {
  @Prop({
    type: [Number, String]
  })
  value!: number | string

  @Prop({
    type: Boolean,
    default: false
  })
  activeItemIsPined!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  mini!: boolean

  drawer: boolean = true

  get openedItem(): ITheSideNavigationUserItem {
    return userStore.openedNavigationItem
  }

  get pinedItems(): ITheSideNavigationUserItem[] {
    return userStore.pinedNavigationItems
  }

  get isPinedItem(): boolean {
    return this.pinedItems.some(item => this.openedItem.id === item.id)
  }

  @Emit('click:search')
  onClickSearch() {}

  @Emit('click:pine-on')
  onClickPineOn(item: ITheSideNavigationUserItem): ITheSideNavigationUserItem {
    return item
  }

  @Emit('click:pine-off')
  onClickPineOff(item: ITheSideNavigationUserItem): ITheSideNavigationUserItem {
    return item
  }

  @Emit('click:pine-clear')
  onClickPineClear(): void {}

  @Emit('click:opened')
  onClickOpenedItem(
    item: ITheSideNavigationUserItem
  ): ITheSideNavigationUserItem {
    return item
  }

  @Emit('click:pined')
  onClickPinedItem(
    item: ITheSideNavigationUserItem
  ): ITheSideNavigationUserItem {
    return item
  }

  @Emit('change:navigation')
  onChangeNavigation(): void {
    console.log('TheSideNavigation - change-navigation')
  }
}
